import { render, staticRenderFns } from "./migrationDone.vue?vue&type=template&id=c03b8fea&"
import script from "./migrationDone.vue?vue&type=script&lang=js&"
export * from "./migrationDone.vue?vue&type=script&lang=js&"
import style0 from "./migrationDone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports